<template>
	<el-dialog
		title="意见反馈"
		:visible.sync="showFeedDialog"
		:close-on-click-modal="false"
        :modal="false"
		width="300px"
		class="feed_box"
		 :before-close="closed"
		 append-to-body
	>
		<div class="content">
			<svg id="bianzu" viewBox="0 0 1267 1024" style="width:90px;height:78px"><path d="M321.18267 514.38a55.718 55.718 0 0 0 15.782-39.73c-1.46-95.079 11.904-226.957 83.763-315.136 50.189-61.44 118.618-91.264 208.691-91.264h5.67c91.15 0 159.924 29.99 210.33 91.814 76.442 93.376 86.49 234.931 85.696 310.963a55.616 55.616 0 0 0 16.832 40.5c12.98 12.62 66.33 72.383 71.373 241.407a27.226 27.226 0 0 1-3.52 8.858 26.88 26.88 0 0 1-7.283 1.024c-8.896 0-19.802-4.838-29.952-13.312a54.835 54.835 0 0 0-74.752 4.096 55.744 55.744 0 0 0-1.702 75.366c5.299 6.016 20.89 24.794 29.67 39.565 4.992 8.218 6.502 17.869 4.186 26.42-3.661 13.414-16.615 25.305-36.775 33.587-43.136 17.984-80.09 27.11-109.875 27.11-54.4 0-96.691-16.909-108.39-23.424-15.514-8.627-31.744-13.018-48.244-13.018-15.321 0-30.668 3.84-45.657 11.367-18.266 9.293-56.807 24.857-109.645 24.857-34.778 0-70.362-6.873-105.907-20.518-23.91-9.088-36.864-28.736-40.602-42.547-2.688-10.15-1.024-19.584 5.427-29.901 4.096-6.656 7.028-11.763 9.588-16.282 4.48-7.872 6.502-11.456 14.272-21.068a55.757 55.757 0 0 0-2.727-72.935 54.848 54.848 0 0 0-72.217-7.117c-10.036 7.22-24.026 15.31-30.592 17.754a6.208 6.208 0 0 1-1.664-1.126 64.717 64.717 0 0 1-1.524-6.58 99.61 99.61 0 0 0-1.484-6.515c-14.848-139.968 53.44-215.936 71.232-234.214M195.46067 756.915c0.192 1.741 0.563 3.43 1.05 5.12 0.473 1.587 0.768 3.251 1.1 4.928 1.767 8.807 4.762 23.527 17.818 35.405 11.264 10.509 25.011 16.09 39.949 16.09 1.651 0 3.328-0.09 5.043-0.218 20.378-1.562 56.934-28.045 56.934-28.045-15.347 19.047-16.09 23.987-27.852 43.034-18.15 29.158-16.5 55.974-11.84 73.497 8.896 32.845 35.328 65.319 74.406 80.154 46.246 17.754 88.525 24.102 125.35 24.102 64.154 0 111.668-19.212 134.452-30.784 7.155-3.61 14.016-5.44 20.812-5.44 7.168 0 14.272 2.023 21.556 6.08 18.777 10.445 69.824 30.362 135.078 30.362 39.744 0 84.736-12.058 130.982-31.334 36.096-14.848 60.544-39.744 68.826-70.221 6.285-23.168 2.675-48.563-10.304-69.978-13.184-22.131-35.443-47.424-35.443-47.424 17.728 14.81 40.55 26.112 65.113 26.112 9.703 0 19.776-1.753 30.183-5.76 20.557-8.345 33.485-34.137 35.648-55.257 0.128-1.23 0.166-2.445 0.153-3.661-4.979-179.418-61.542-256.039-88.243-282.01 0.947-89.574-12.057-241.497-98.278-346.829C827.35867 50.483 742.18667 12.8 635.08967 12.8h-5.146c-106.624 0-191.334 37.504-251.801 111.514-81.728 100.262-97.946 243.89-96.295 351.219-28.697 29.427-104.205 122.304-86.387 281.382m24.525 141.824c-0.23-17.766 2.01-38.63 8.96-56.064-6.95 0.896-14.336 1.536-22.375 1.536-23.385 0-47.36-4.685-71.462-13.939-11.29-4.3-18.342-13.696-20.262-20.813-0.717-2.765-0.666-5.504 2.227-10.137 3.072-5.018 5.286-8.91 7.219-12.314 3.072-5.466 4.122-7.296 8.998-13.402a55.718 55.718 0 0 0-2.854-72.857 54.835 54.835 0 0 0-40.077-17.344 54.82 54.82 0 0 0-32.102 10.368 75.686 75.686 0 0 1-2.637 1.817c-5.594-91.046 38.95-130.086 48.448-139.904a55.642 55.642 0 0 0 15.693-39.641c-1.024-66.829 8.128-159.27 57.446-220.058 20.634-25.408 47.347-41.766 78.592-51.29 6.49-21.503 14.541-44.083 23.936-62.54-59.865 7.616-108.672 33.792-145.19 78.694C75.20467 333.94 63.44167 438.681 64.65767 516.915c-20.826 21.453-75.661 81.639-62.695 197.581 0.128 1.28 0.384 2.522 0.768 3.75 0.333 1.152 0.55 2.381 0.807 3.572 1.293 6.438 3.456 17.164 12.928 25.83 8.192 7.642 18.163 11.712 28.979 11.712 1.229 0 2.432-0.051 3.66-0.128 14.81-1.14 41.345-20.442 41.345-20.442-11.136 13.901-11.7 17.472-20.224 31.36-13.197 21.248-11.994 40.807-8.602 53.581 6.451 23.936 25.639 47.629 53.99 58.445 33.55 12.928 64.231 17.562 90.983 17.562 4.787-0.064 8.87-0.756 13.389-1.012m983.168-384.678c0.691-65.293-8.755-176.051-71.309-252.864-36.531-45.005-85.53-71.296-145.549-79.002 9.331 20.301 15.923 40.768 22.119 61.517 32.307 9.319 59.328 26.112 80.844 52.66 52.48 64.422 59.392 163.66 58.804 217.075a54.925 54.925 0 0 0 16.537 40.192c8.346 8.896 41.728 39.424 47.04 147.11a36.147 36.147 0 0 1-4.3-3.162 54.822 54.822 0 0 0-74.753 3.943 55.744 55.744 0 0 0-1.83 75.353c4.173 4.775 14.464 17.447 19.955 26.688a10.24 10.24 0 0 1 1.408 7.616c-1.357 4.967-8.128 10.496-17.971 14.567-29.03 12.16-54.592 18.598-73.856 18.598-8.192 0-15.86-0.717-23.066-1.638 5.402 16.704 9.255 37.696 10.47 56.23 4.263 0.256 8.116 0.896 12.545 0.896 28.838 0 61.517-8.806 95.065-22.873 26.202-10.816 43.943-28.98 49.946-51.2 4.544-16.858 1.92-35.405-7.462-50.996-9.588-16.128-25.728-34.56-25.728-34.56 12.85 10.79 29.414 19.034 47.257 19.034 7.04 0 14.349-1.28 21.914-4.186 14.925-6.08 24.281-24.883 25.856-40.294 0.077-0.896 0.128-1.78 0.102-2.675-3.597-130.752-44.672-179.123-64.038-198.029" fill="#14A8F0"></path></svg>
			<p class="press_p">数科OFD交流群</p>
            <p class="press_b">946014825</p>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="joinBtn" size="mini" class="mini_btn">加入QQ群</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		showFeedDialog: {
			type: Boolean,
			default: true
        },
	},
	data() {
		return {

		};
	},
	watch:{

	},
	computed: {

	},
	methods: {
		joinBtn() {
			window.open("https://jq.qq.com/?_wv=1027&k=buqIcKXH","_blank");
		},
        closed(){
            this.$emit('closed',false)
        }
	}
};
</script>
<style lang="scss">
.feed_box .el-dialog__body{
    padding-bottom: 0!important;
}
</style>
<style lang="scss" scoped>
.content{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1em;
    p{
        margin-bottom: 1em;
    }
    .press_p{
        font-size: 16px;
    }
    .press_b{
        font-size: 14px;
    }
}
.dialog-footer{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/feedback/index.vue